// src/global/Globalapi.js
import axios from 'axios';
import { encodeId, decodeId } from './Globalfunction'; // ✅ imported, no need to redefine
export const BRAND_NAME = "Malar's Bakers";

const GOOGLE_CLIENT_IDS = {
  local: "719432044983-02pbu246ppfunrba31bl051usr2od4hr.apps.googleusercontent.com",
  prod: "566520368788-4e6l4ppo1ojgfl6lu7ce3688olac7q9j.apps.googleusercontent.com",
};

export const GOOGLE_CLIENT_ID = (() => {

  const host = window.location.hostname;

  // ✅ Local development
  if (host === "localhost" || host === "127.0.0.1") {
    return GOOGLE_CLIENT_IDS.local;
  }

  // ✅ Production (.com / vercel)
  if (
    host === "malarsbakers.com" ||
    host === "www.malarsbakers.com" ||
    host === "malarsbakers.vercel.app"
  ) {
    return GOOGLE_CLIENT_IDS.prod;
  }

  // ✅ Fallback (safe default)
  return GOOGLE_CLIENT_IDS.prod;
})();

const getBaseUrl = () => {
  const host = window.location.hostname;

  if (host === 'localhost') {
    return 'http://localhost:5000';
  }
  
  // if (host === 'stage.boltandbrook.com' || host === 'stage-sell.boltandbrook.com') {
  //   return 'http://stage-api.boltandbrook.com';
  // }

  if (host === 'malarsbakers.com' || host === 'malarsbakers.vercel.app') {
    // return 'http://api.malarsbakers.com';
    return 'https://apimalarsbakers.postulateinfotech.in';
  }

  // fallback
  return window.location.origin;
};

const getDomainurl = () => {
  const host = window.location.hostname;

  if (host === 'localhost') {
    return 'http://localhost:5000';
  }
  
  if (host === 'stage.boltandbrook.com' || host === 'stage-sell.boltandbrook.com') {
    return 'http://stage-api.boltandbrook.com';
  }

  if (host === 'boltandbrook.com' || host === 'sell.boltandbrook.com') {
    return 'http://api.boltandbrook.com';
  }

  // fallback
  return window.location.origin;
};

const axiosClient = axios.create({

  baseURL: getBaseUrl(),

  withCredentials: true,
});

const withApiPrefix = (url) => `/api${url}`;

export const getData = (url, params = {}) =>
  axiosClient.get(withApiPrefix(url), { params });

export const postData = (url, data) =>
  axiosClient.post(withApiPrefix(url), data);

export const putData = (url, data) =>
  axiosClient.put(withApiPrefix(url), data);

export const deleteData = (url) =>
  axiosClient.delete(withApiPrefix(url));

export {
  encodeId,
  decodeId,
  getBaseUrl,
};


export default axiosClient;
